import { useQuery } from '@apollo/client'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { BurgerSection } from '@src/components/Drawer/DrawerHeader'
import { LoadingSpinner } from '@src/components/Loaders/LoadingSpinner'
import { useNotLoggedInRedirect } from '@src/hooks/useNotLoggedInRedirect'

import { getSingleOrderDocument } from '../SingleOrder/queries/__generated__/getSingleOrder.graphql-interface'

import { OrderReviewForm } from './OrderReviewForm'

export const OrderReview: React.FC<{ orderId: string }> = ({ orderId }) => {
  useNotLoggedInRedirect()
  const { t } = useTranslation('singleOrder')

  const { data, loading } = useQuery(getSingleOrderDocument, {
    variables: { id: orderId },
    fetchPolicy: 'cache-and-network',
  })

  const myOrder = data?.myOrder

  return loading ? (
    <LoadingSpinner text={t('searching_for_order')} />
  ) : (
    <BurgerSection header={{ title: t('review_order_header') }}>
      {!myOrder ? (
        <div>{t('this_order_doesnt_exist')}.</div>
      ) : (
        <OrderReviewForm
          orderNumber={myOrder.orderNumber}
          orderId={myOrder.id}
          outletName={myOrder.outlet.displayName}
          cleanOrderStatus={myOrder.cleanOrderStatus}
          fulfilmentMethod={myOrder.narrowFulfilmentMethod}
          allowReviewText={myOrder.outlet.allowReviewText}
        />
      )}
    </BurgerSection>
  )
}
